<template lang="pug">
.vue-referrals
	//welcome(v-if="mode === 'welcome'", @goToPage="mode = $event" :data="referee", :config="config")
	email-form(v-if="mode === 'email-form' || mode === 'welcome'" @goToPage="mode = $event", @submit="submitEmail()", :data="friend", :config="config")
	thank-you(v-if="mode === 'thank-you'", @resetForm="resetForm()", :data="referee", :config="config")
</template>

<script>
import axios from "axios";
import EmailForm from "./views/email-form.vue";
import ThankYou from "./views/thank-you.vue";
//import Welcome from "./views/welcome.vue";

export default {
  name: "App",
  components: {
    EmailForm,
    ThankYou,
    //Welcome,
  },
  data() {
    return {
      mode: "email-form",
      referee: {
        name: "",
        email: "",
        refereeFriendName: "",
        refereeFriendEmail: "",
        memberNumber: "",
        phoneNumber: "",
        subjectLine: "",
        note: "",
      },
      friend: {
        name: "",
        email: "",
        phone: "",
        member: "",
        refName: "",
        refEmail: "",
        refSubject: document.querySelector("#emailSubject").value,
        refNote: document.querySelector("#emailNote").value,
      },
      emailData: {
        name: "",
        membername: "",
        email: "",
        subject: "",
        note: "",
        userGuid: "",
        refereePageUrl: "",
        source: "",
      },
      memberEmailData: {
        name: "",
        email: "",
      },
      config: {
        sendDisable: false,
        sendEmailApi: document.querySelector("#sendEmailApi").value,
        sendMemberEmailApi: document.querySelector("#sendMemberEmailApi").value,
        getItemApi: document.querySelector("#getItemApi").value,
        thankYouCopy: document.querySelector("#thankYouCopy").value,
        refereePageUrl: document.querySelector("#refereePageUrl").value,
        shareText: document.querySelector("#shareText").value,
      },
    };
  },
  methods: {
    resetForm() {
      this.mode = "email-form";
      Object.keys(this.referee).forEach((key) => {
        this.referee[key] = "";
      });
      Object.keys(this.friend).forEach((key) => {
        this.friend[key] = "";
      });
      this.friend.refSubject = document.querySelector("#emailSubject").value;
      this.friend.refNote = document.querySelector("#emailNote").value;
    },
    submitEmail() {
      this.referee.name = this.friend.name;
      this.referee.email = this.friend.email;
      this.referee.refereeFriendEmail = this.friend.refEmail;
      this.referee.refereeFriendName = this.friend.refName;
      this.referee.memberNumber = this.friend.member;
      this.referee.phoneNumber = this.friend.phone;
      this.referee.note = this.friend.refNote;
      this.referee.subjectLine = this.friend.refSubject;
      axios
        .post(this.config.getItemApi, this.referee)
        .then((res) => {
          console.log(JSON.stringify(res));

          if (res.data.success) {
            console.log("Friend Name: " + this.friend.name);

            console.log(JSON.stringify(this.friend));

            this.emailData.name = this.friend.refName;
            this.emailData.membername = this.friend.name;
            this.emailData.email = this.friend.refEmail;
            this.emailData.subject = this.friend.refSubject;
            this.emailData.note = this.friend.refNote;
            this.emailData.userGuid = res.data.userGuid;
            this.emailData.refereePageUrl = this.config.refereePageUrl;
            this.emailData.source = "email";

            axios
              .post(this.config.sendEmailApi, this.emailData)
              .then((emailRes) => {
                Object.keys(this.friend).forEach((key) => {
                  this.friend[key] = "";
                });
                Object.keys(this.emailData).forEach((key) => {
                  this.emailData[key] = "";
                });
                this.config.sendDisable = false;
                this.mode = "thank-you";
                setTimeout(() => {
                  let referals = document.querySelector(".vue-referrals");
                  let additionalOffset = 64;
                  window.scrollTo({
                    top: referals.offsetTop - additionalOffset,
                    behavior: "smooth",
                  });
                }, 1);
              })
              .catch((emailErr) => {
                console.error("There was an error!", emailErr);
              });

            this.memberEmailData.name = this.friend.name;
            this.memberEmailData.email = this.friend.email;
            axios
              .post(this.config.sendMemberEmailApi, this.memberEmailData)
              .then((emailRes) => {
                Object.keys(this.memberEmailData).forEach((key) => {
                  this.memberEmailData[key] = "";
                });
                this.config.sendDisable = false;
                this.mode = "thank-you";
                setTimeout(() => {
                  let referals = document.querySelector(".vue-referrals");
                  let additionalOffset = 64;
                  window.scrollTo({
                    top: referals.offsetTop - additionalOffset,
                    behavior: "smooth",
                  });
                }, 1);
              })
              .catch((emailErr) => {
                console.error("There was an error!", emailErr);
              });
          } else {
            console.error("There was an error! getItemApi POST");
          }
        })
        .catch((err) => {
          console.error("There was an error! GENERAL", err);
        });
    },
  },
};
</script>

<style lang="scss"></style>
